import React, { useEffect } from "react"
import { useLocation, useParams } from "react-router-dom"

import { Obj, load, navigateTo as navigateToScrivitoObj } from "scrivito"
import { NOT_FOUND } from "shared/constants/permalinks"

import { useNavigateToPermalink } from "features/navigation/model/useNavigateToPermalink"

import { LoadingBuildingReferencePage } from "./LoadingBuildingReferencePage"

function getBuildingReferenceObj(
  locale: string | undefined,
  referenceID: string | undefined
) {
  return load(() => {
    if (!referenceID) {
      throw new Error("Missing referenceID!")
    }
    if (!locale) {
      throw new Error("Missing Locale!")
    }
    return Obj.onSite(locale)
      .where("_objClass", "equals", "BuildingReference")
      .and("referenceID", "equals", referenceID)
      .first()
  })
}

export const BuildingReferenceRedirectPage = React.memo(() => {
  const { locale, referenceID } = useParams()
  const { hash } = useLocation()
  const { navigate: navigateToNotFoundPage } = useNavigateToPermalink(NOT_FOUND)

  useEffect(() => {
    getBuildingReferenceObj(locale, referenceID)
      .then(obj => {
        if (obj) {
          navigateToScrivitoObj(obj, { hash })
        } else {
          navigateToNotFoundPage()
          throw new Error(`No Obj with referenceID: ${referenceID} found!`)
        }
      })
      .catch(() => {
        navigateToNotFoundPage()
      })
  }, [referenceID])

  return <LoadingBuildingReferencePage />
})
